/* M+RC NOIR — conversion + SEO helpers: trust line, sticky ATC, cart free-ship bar, single-H1, title */
(function(){
  if (window.__mnConv) return; window.__mnConv = true;
  var THRESH = { USD:75, EUR:99, GBP:89, CAD:150, JPY:16000 };
  var SYM = { USD:'$', EUR:'€', GBP:'£', CAD:'CA$', JPY:'¥' };
  function activeCurrency(){ try{ if(window.Shopify&&Shopify.currency&&Shopify.currency.active) return Shopify.currency.active; }catch(e){} return 'EUR'; }
  function fmt(cur, amt){ var s=SYM[cur]||(cur+' '); if(cur==='JPY') return s+Math.round(amt); return s+(Math.round(amt*100)/100).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:2}); }

  function placeTrust(buttons){
    var ul=document.querySelector('.mn-trust');
    if(!ul){
      var cur=activeCurrency(); var th=THRESH[cur];
      var ship= th ? ('Free shipping over '+fmt(cur,th)) : 'Fast tracked shipping';
      var check='<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\"><path d=\"M20 6L9 17l-5-5\"/></svg>';
      ul=document.createElement('ul'); ul.className='mn-trust';
      ul.innerHTML='<li>'+check+'<span>'+ship+'</span></li><li>'+check+'<span>Easy returns</span></li><li>'+check+'<span>Secure checkout</span></li>';
    }
    if(ul.parentNode!==buttons || ul!==buttons.lastElementChild){ buttons.appendChild(ul); }
  }

  function initPDP(){
    var buttons = document.querySelector('.product-form__buttons');
    if(!buttons) return;
    placeTrust(buttons);
    if(!document.querySelector('.mn-sticky-atc')){
      var realBtn=buttons.querySelector('button[name=\"add\"], .product-form__submit');
      var titleEl=document.querySelector('.product__title') || document.querySelector('h1');
      var title=titleEl?titleEl.textContent.trim():'';
      var bar=document.createElement('div'); bar.className='mn-sticky-atc';
      bar.innerHTML='<div class=\"mn-sticky-atc__info\"><span class=\"mn-sticky-atc__title\"></span><span class=\"mn-sticky-atc__price\"></span></div><button type=\"button\" class=\"mn-sticky-atc__btn\">Add to bag</button>';
      bar.querySelector('.mn-sticky-atc__title').textContent=title;
      document.body.appendChild(bar);
      function syncPrice(){ var priceEl=document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--regular, .price .price-item'); var p=priceEl?priceEl.textContent.trim():''; bar.querySelector('.mn-sticky-atc__price').textContent=p; if(realBtn){ var sold=realBtn.hasAttribute('disabled'); var b=bar.querySelector('.mn-sticky-atc__btn'); b.disabled=sold; b.textContent=sold?'Sold out':'Add to bag'; } }
      syncPrice();
      bar.querySelector('.mn-sticky-atc__btn').addEventListener('click', function(){ if(realBtn) realBtn.click(); });
      if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(window.innerWidth>=750){ bar.classList.remove('is-visible'); return; } if(!e.isIntersecting && e.boundingClientRect.top<0) bar.classList.add('is-visible'); else bar.classList.remove('is-visible'); }); },{threshold:0}); io.observe(buttons); }
      document.addEventListener('change', function(e){ if(e.target.closest && e.target.closest('product-form, variant-radios, variant-selects')) setTimeout(syncPrice,120); });
    }
  }

  /* ---- SEO: single H1 + clean title on product pages ---- */
  function initSEO(){
    try{
      var isProduct = !!document.querySelector('product-form');
      var ptEl = document.querySelector('h1.product__title') || document.querySelector('.product__title');
      var pt = ptEl ? ptEl.textContent.trim() : '';
      var h1s = [].slice.call(document.querySelectorAll('h1'));
      if (h1s.length > 1){
        var keep = null;
        for (var k=0;k<h1s.length;k++){ if(h1s[k].classList.contains('product__title')){ keep=h1s[k]; break; } }
        if(!keep) keep = h1s[0];
        h1s.forEach(function(h){
          if(h===keep) return;
          var h2=document.createElement('h2');
          for(var i=0;i<h.attributes.length;i++){ h2.setAttribute(h.attributes[i].name, h.attributes[i].value); }
          h2.setAttribute('data-mn-demoted','1');
          while(h.firstChild){ h2.appendChild(h.firstChild); }
          if(h.parentNode){ h.parentNode.replaceChild(h2,h); }
        });
      }
      if (isProduct && pt && document.title.indexOf('| M+RC NOIR')===-1){
        document.title = pt + ' | M+RC NOIR';
      }
    }catch(e){}
  }

  var fsTimer=null;
  function renderFreeshipDebounced(){ clearTimeout(fsTimer); fsTimer=setTimeout(renderFreeship,150); }
  function renderFreeship(){
    var host=document.querySelector('#mini-cart .inner-cart'); if(!host) return;
    fetch(window.location.origin+'/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var cur=cart.currency||activeCurrency(); var th=THRESH[cur];
      var bar=host.querySelector('.mn-freeship');
      if(!th || cart.item_count===0){ if(bar) bar.remove(); return; }
      var total=cart.total_price/100; var remaining=th-total;
      if(!bar){ bar=document.createElement('div'); bar.className='mn-freeship'; bar.innerHTML='<p class=\"mn-freeship__msg\"></p><div class=\"mn-freeship__track\"><div class=\"mn-freeship__fill\"></div></div>'; host.insertBefore(bar, host.firstChild); }
      var pct=Math.max(0,Math.min(100,(total/th)*100));
      var msg=bar.querySelector('.mn-freeship__msg'); var fill=bar.querySelector('.mn-freeship__fill');
      if(remaining<=0){ bar.classList.add('is-unlocked'); msg.innerHTML='🎉 You\'ve unlocked <b>free shipping</b>!'; fill.style.width='100%'; }
      else { bar.classList.remove('is-unlocked'); msg.innerHTML='You\'re <b>'+fmt(cur,remaining)+'</b> away from <b>free shipping</b>'; fill.style.width=pct+'%'; }
    }).catch(function(){});
  }
  function initCart(){
    var mc=document.getElementById('mini-cart'); if(!mc) return;
    renderFreeship();
    new MutationObserver(function(){ if(mc.classList.contains('active')) renderFreeship(); }).observe(mc,{attributes:true,attributeFilter:['class']});
    var inner=mc.querySelector('.inner-cart');
    if(inner) new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ var t=muts[i].target; if(!t.closest || !t.closest('.mn-freeship')){ renderFreeshipDebounced(); return; } } }).observe(inner,{childList:true,subtree:true});
  }
  function start(){ try{ initPDP(); }catch(e){} try{ initSEO(); }catch(e){} try{ initCart(); }catch(e){} }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
  window.addEventListener('load',start);
  document.addEventListener('shopify:section:load',start);
  document.addEventListener('shopify:section:select',start);
  setTimeout(start, 1200);
})();
